import { Suspense } from "react";
import VehicleWrapper from "./vehicle";

export default function VehiclePage() {
	return (
		<Suspense fallback={<div>Loading...</div>}>
			<VehicleWrapper />
		</Suspense>
	);
}
